module.exports = __webpack_public_path__ + "img/regional-office-alternative-location-analisys.387f12ab.svg";